import queryString from "query-string";

import { getProPageHeaders } from "@similarweb/pro-logic-components";
import Sentry from "@similarweb/sentry-logger";

import type { User } from "app/components/impersonate-popup/types";

export const getUserIdentities = async (
    token: string,
    searchInField: string,
    page: number,
    pageSize: number,
    signal?: AbortSignal,
): Promise<User[]> => {
    const queryStringParams = queryString.stringify({ searchTerm: token, searchField: searchInField, page, pageSize });
    const response = await fetch(`api/internal/impersonation?${queryStringParams}`, {
        signal,
        headers: getProPageHeaders(),
    });
    if (!response.ok) {
        Sentry.errorTracker({
            message: "Impersonate: failed to fetch user identities",
            e: new Error(response.statusText),
            level: "error",
        });
        throw new Error("Failed to fetch user identities");
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const json = (await response.json()) as { Items: User[] };
    return json.Items;
};
